module.exports = __webpack_public_path__ + "img/remove.fb501a26.svg";